export default __webpack_public_path__ + "static/media/snow.608095c0.jpg";